import React from "react";
import { motion } from "framer-motion";

import styles from "./styles.module.scss";

const ReviewCard = ({
  reviews,
  currentIndex
}) => {
  return (
    <motion.div
      key={currentIndex}
      className={styles.card}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8 }}
    >
      <img src={reviews[currentIndex].image} alt={reviews[currentIndex].title} />
      <div>
        <h3>{reviews[currentIndex].title}</h3>
        <p>{reviews[currentIndex].text}</p>
      </div>
    </motion.div>
  );
};

export default ReviewCard;
